import { NavLink } from "react-router-dom";
import classNames from "classnames";

function NavigationLink({ className, text, to, openInNewTab, url }) {
  return (
    <li>
      <NavLink
        to={openInNewTab && url ? url : to}
        className={({ isActive }) =>
          classNames(className, isActive ? "active" : "", "nav-link")
        }
        state={{
          canGoBack: true,
        }}
        target={openInNewTab ? "_blank" : ""}
        rel={openInNewTab ? "noreferrer" : ""}
      >
        {text}
      </NavLink>
    </li>
  );
}

export default NavigationLink;
